import { useState, useEffect } from 'react'
import { api } from '../../services/api.js'
import './KnowledgeBox.css'

export default function KnowledgeBox({ personId, firstName }) {
  const [state, setState] = useState('idle') // 'idle' | 'loading' | 'done' | 'error'
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (state !== 'loading') { setElapsed(0); return }
    const t = setInterval(() => setElapsed(s => s + 1), 1000)
    return () => clearInterval(t)
  }, [state])

  async function generate() {
    setState('loading')
    setError(null)
    setElapsed(0)
    try {
      const result = await api.post(`/ai/knowledge/${personId}`)
      setData(result.data)
      setState('done')
    } catch (err) {
      setError(err.message || 'Something went wrong')
      setState('error')
    }
  }

  if (state === 'idle') {
    return (
      <div className="knowledge-box knowledge-box--prompt">
        <div className="knowledge-box__prompt-inner">
          <span className="knowledge-box__spark">✦</span>
          <div>
            <div className="knowledge-box__prompt-title">Did you know?</div>
            <div className="knowledge-box__prompt-sub">
              Discover 3 surprising facts from the era and place {firstName || 'this person'} lived in.
            </div>
          </div>
          <button className="btn btn-ghost btn-sm knowledge-box__trigger" onClick={generate}>
            Explore era
          </button>
        </div>
      </div>
    )
  }

  if (state === 'loading') {
    return (
      <div className="knowledge-box knowledge-box--loading">
        <div className="knowledge-box__loader">
          <span className="knowledge-box__spark spinning">✦</span>
          <span>
            Researching the era{elapsed > 8 ? ' — this can take up to 30 seconds…' : '...'}
          </span>
        </div>
      </div>
    )
  }

  if (state === 'error') {
    return (
      <div className="knowledge-box knowledge-box--error">
        <p>{error}</p>
        <button className="btn btn-ghost btn-sm" onClick={generate}>Try again</button>
      </div>
    )
  }

  // Done
  const { era_label, facts = [] } = data || {}

  return (
    <div className="knowledge-box knowledge-box--done">
      <div className="knowledge-box__header">
        <span className="knowledge-box__spark">✦</span>
        <div>
          <div className="knowledge-box__label">Did you know?</div>
          {era_label && <div className="knowledge-box__era">{era_label}</div>}
        </div>
        <button
          className="knowledge-box__refresh"
          onClick={generate}
          title="Refresh"
          aria-label="Regenerate"
        >
          ↻
        </button>
      </div>

      <div className="knowledge-box__facts">
        {facts.map((fact, i) => (
          <div key={i} className="knowledge-fact">
            {fact.year && (
              <div className="knowledge-fact__year">{fact.year}</div>
            )}
            <div className="knowledge-fact__headline">{fact.headline}</div>
            <div className="knowledge-fact__detail">{fact.detail}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
